import React, { useState, useEffect, useRef } from 'react';
import { db, Storage, auth } from '../firebase';
import { ref, uploadBytes, getDownloadURL} from 'firebase/storage';
import { setDoc, doc, collection,serverTimestamp, getDoc } from 'firebase/firestore';
import { useLocation, useNavigate } from 'react-router-dom';

import 'react-circular-progressbar/dist/styles.css';
import '../style/DesignUpload.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Canvas, Rect, Image as FabricImage } from 'fabric';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Modal from '../components/Modal';
import {  FaTimes, FaTrash, FaUndo, FaShopify } from 'react-icons/fa';


 const joggersProduct =   
  {
      // id: 19,
      name: 'Cotton Joggers',
      title: 'joggers',
      images: ['joggersFront.jpg', 'joggersBack.jpg'],
      description: 'Cotton Joggers',
      fabric: '100% Cotton',
      BASE_COST: 570,
      tax: 'tax',
      mockups: ['joggersFront.jpg', 'joggersBack.jpg'],
      texture: '22.png',
      GSM: '290 GSM',
      productType: 'joggers',
      costStructure: {
        'DTF Epson': {
          logo: 36,
          LessthenA4: 66,
          A4less: 76,
          A4: 76,
          A3: 76,
         full: 76,
        },
      },
      clippingRects: {
        front: [
          { left: 560, top: 1150, width: 500, height: 1500 }, // Lower front left
          { left: 1150, top: 1150, width: 500, height: 1500 },  // Lower front right
          { left: 600, top: 650, width: 400, height: 400 }, // Upper front
          { left: 1200, top: 650, width: 400, height: 400 } // Upper front right
        ],
        back: [
          { left: 560, top: 1150, width: 500, height: 1500 }, // Lower front left
          { left: 1150, top: 1150, width: 500, height: 1500 },  // Lower front right
          { left: 650, top: 400, width: 900, height: 400 }, // Upper front
        ]
      },
      print_method: ["DTF Epson"],
      sizeChart: 'joggersSizeChart.jpg',
      sizes: ['S', 'M', 'L', 'XL']
    };

const DesignJoggers = () => {
  const product = joggersProduct;
  const frontCanvasRef = useRef(null);
  const backCanvasRef = useRef(null);
  const [frontCanvas, setFrontCanvas] = useState(null);
  const [backCanvas, setBackCanvas] = useState(null);
  
  // Updated design images state to handle multiple areas
  const [designImages, setDesignImages] = useState({
    frontLeftFull: null,
    frontRightFull: null,
    frontLeftLogo: null,
    frontRightLogo: null,
    backLeftFull: null,
    backRightFull: null,
    backBumArea: null
  });
  
  const [designImageUrls, setDesignImageUrls] = useState({
    frontLeftFull: null,
    frontRightFull: null,
    frontLeftLogo: null,
    frontRightLogo: null,
    backLeftFull: null,
    backRightFull: null,
    backBumArea: null
  });
  
  const [view, setView] = useState(0); 
  const [selectedPrintArea, setSelectedPrintArea] = useState('frontLeftFull');
  const [designName, setDesignName] = useState('');
  const [description, setDescription] = useState('');
  const [designFileNames, setDesignFileNames] = useState({
    frontLeftFull: '',
    frontRightFull:'',
    frontLeftLogo: '',
    frontRightLogo: '',
    backLeftFull: '',
    backRightFull: '',
    backBumArea: ''
  });
  
  // Design sizes for each area
  const [designSizes, setDesignSizes] = useState({
    frontLeftFull: { width: 0, height: 0 },
    frontRightFull:{ width: 0, height: 0 },
    frontLeftLogo: { width: 0, height: 0 },
    frontRightLogo: { width: 0, height: 0 },
    backLeftFull: { width: 0, height: 0 },
    backRightFull: { width: 0, height: 0 },
    backBumArea: { width: 0, height: 0 }
  });
  
  // Design costs for each area
  const [designCosts, setDesignCosts] = useState({
    frontLeftFull: 0,
    frontRightFull:0,
    frontLeftLogo: 0,
    frontRightLogo: 0,
    backLeftFull: 0,
    backRightFull: 0,
    backBumArea: 0
  });
  
  const [progress, setProgress] = useState(0);
  const [sellingPrice, setSellingPrice] = useState('');
  const [totalPrice, setTotalPrice] = useState(0);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [userShop, setUserShop] = useState(null);

  const productName = product?.name || 'Cotton Joggers';
  const productGSM = product?.GSM;
  const sizeChart = product?.sizeChart;
  const printMethod = product?.print_method;
  const sizes = product?.sizes;
  const tax = product?.tax;
  const baseCost = product?.BASE_COST; 
  
  const [errors, setErrors] = useState({
    designName: '',
    description: '',
    sellingPrice: '',
    designImages: '',
    selectedMethod: '',
  });

  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false); 
  const [selectedMethod, setSelectedMethod] = useState(null);
  const navigate = useNavigate();
  const [availablePrintMethods, setAvailablePrintMethods] = useState([]);
  const [isSizeChartVisible, setIsSizeChartVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false); 

  const user = auth.currentUser;
  if (!user) {
    throw new Error("User not logged in");
  }

  // Print area options
  const printAreaOptions = {
    front: [
      { value: 'frontLeftFull', label: 'Left Leg Full Print (W-8" H-20")', maxWidth: 8, maxHeight: 20 },
      { value: 'frontRightFull', label: 'Right Leg Full Print (W-8" H-20")', maxWidth: 8, maxHeight: 20 },
      { value: 'frontLeftLogo', label: 'Left Leg Logo Print (W-5" H-5")', maxWidth: 5, maxHeight: 5 },
      { value: 'frontRightLogo', label: 'Right Leg Logo Print (W-5" H-5")', maxWidth: 5, maxHeight: 5 },
    ],
    back: [
      { value: 'backLeftFull', label: 'Left Leg Full Print (W-8" H-20")', maxWidth: 8, maxHeight: 20 },
      { value: 'backRightFull', label: 'Right Leg Full Print (W-8" H-20")', maxWidth: 8, maxHeight: 20 },
      { value: 'backBumArea', label: 'Bum Area Print (W-14" H-7")', maxWidth: 14, maxHeight: 7 }
    ]
  };

  useEffect(() => {
    const initCanvas = (ref) => {
      return new Canvas(ref.current, {
        width: 2200,
        height: 2700,
        backgroundColor: "#fff",
        enableRetinaScaling: false
      });
    };

    const frontFabricCanvas = initCanvas(frontCanvasRef);
    const backFabricCanvas = initCanvas(backCanvasRef);

    setFrontCanvas(frontFabricCanvas);
    setBackCanvas(backFabricCanvas);

    return () => {
      frontFabricCanvas.dispose();
      backFabricCanvas.dispose();
    };
  }, []);

  useEffect(() => {
    if (product && product.print_method) {
      setAvailablePrintMethods(product.print_method);
      
      const savedPrintMethod = sessionStorage.getItem('selectedPrintMethod');
      
      if (savedPrintMethod) {
        setSelectedMethod(savedPrintMethod);
      } else if (product.print_method.length === 1) {
        setSelectedMethod(product.print_method[0]);
      } else if (product.print_method.length > 1) {
        setSelectedMethod(product.print_method[0]);
      }
    }
  }, [product]);

  useEffect(() => {
    const loadMockupAndTexture = async (canvas, viewIndex) => {
      if (product && product.mockups) {
        try {
          const img = await FabricImage.fromURL(product.mockups[viewIndex]);
          canvas.set("backgroundImage", img);
          img.scaleToWidth(canvas.width);
          img.scaleToHeight(canvas.height);
          canvas.renderAll();

          // Add clipping rectangles for joggers
          const clippingRects = viewIndex === 0 ? 
            product.clippingRects.front.map((rect, index) => new Rect({
              left: rect.left,
              top: rect.top,
              width: rect.width,
              height: rect.height,
              selectable: false,
              evented: false,
              stroke: 'white',
              strokeWidth: 3,
              strokeDashArray: [4, 4],
              fill: 'rgba(0,0,0,0)',
              id: `clippingRectFront${index}`,
              absolutePositioned: true,
            })) :
            product.clippingRects.back.map((rect, index) => new Rect({
              left: rect.left,
              top: rect.top,
              width: rect.width,
              height: rect.height,
              selectable: false,
              evented: false,
              stroke: 'white',
              strokeWidth: 3,
              strokeDashArray: [4, 4],
              fill: 'rgba(0,0,0,0)',
              id: `clippingRectBack${index}`,
              absolutePositioned: true,
            }));

          clippingRects.forEach((rect) => canvas.add(rect));
          canvas.clipPaths = clippingRects;
          canvas.renderAll();
        } catch (error) {
          console.error("Error loading mockup image:", error);
        }
      }
    };

    if (frontCanvas) loadMockupAndTexture(frontCanvas, 0);
    if (backCanvas) loadMockupAndTexture(backCanvas, 1);
  }, [product, frontCanvas, backCanvas]);

  useEffect(() => {
    const totalCost = Object.values(designCosts).reduce((sum, cost) => sum + cost, 0);
    const calculatedTotalPrice = (product?.BASE_COST || 0) + totalCost; 
    setTotalPrice(calculatedTotalPrice);
  }, [designCosts, product?.BASE_COST]);

  const handleSellingPriceChange = (e) => {
    setSellingPrice(e.target.value);
  };

  const updateCostAndSize = (widthUnits, heightUnits, printArea) => {
    const area = widthUnits * heightUnits;
    let newCost = 0;
  
    if (widthUnits > 0 && heightUnits > 0) {
      if (selectedMethod && product?.costStructure?.[selectedMethod]) {
        const selectedCostStructure = product.costStructure[selectedMethod];
  
        if (area <= 25) {
          newCost = selectedCostStructure.logo || 0;
        } else if (area <= 63) {
          newCost = selectedCostStructure.LessthenA4 || 0;
        } else if (area <= 97.11) {
          newCost = selectedCostStructure.A4 || 0;
        } else if (area <= 144) {
          newCost = selectedCostStructure.A4less || 0;
        } else if (area <= 224) {
          newCost = selectedCostStructure.A3 || 0;
        } else if (area <= 320) {
          newCost = selectedCostStructure.full || 0;
        } else {
          newCost = selectedCostStructure.full || 0;
        }
      }
    }
  
    setDesignSizes(prev => ({
      ...prev,
      [printArea]: { width: widthUnits, height: heightUnits }
    }));
    
    setDesignCosts(prev => ({
      ...prev,
      [printArea]: newCost
    }));

    return newCost;
  };

  const handlePrintMethodChange = (printMethod) => {
    setSelectedMethod(printMethod);
    sessionStorage.setItem('selectedPrintMethod', printMethod);
    window.location.reload();
  };

  const handlePrintAreaChange = (e) => {
    const newArea = e.target.value;
    setSelectedPrintArea(newArea);
    
    // Auto-switch view based on selected area
    if (newArea.startsWith('front')) {
      setView(0);
    } else if (newArea.startsWith('back')) {
      setView(1);
    }
  };

  const getClippingRectForArea = (printArea) => {
    const areaIndex = {
      frontLeftFull: 0,
      frontRightFull:1,
      frontLeftLogo: 2,
      frontRightLogo: 3,
      backLeftFull: 0,
      backRightFull: 1,
      backBumArea: 2
    };
    
    const isBackArea = printArea.startsWith('back');
    const rects = isBackArea ? product?.clippingRects?.back : product?.clippingRects?.front;
    return rects?.[areaIndex[printArea]];
  };

  const getMaxDimensionsForArea = (printArea) => {
    const area = printAreaOptions.front.find(opt => opt.value === printArea) || 
                 printAreaOptions.back.find(opt => opt.value === printArea);
    return area ? { maxWidth: area.maxWidth, maxHeight: area.maxHeight } : { maxWidth: 16, maxHeight: 20 };
  };



const handleFileUpload = (e) => {
  const file = e.target.files[0];
  const activeCanvas = view === 0 ? frontCanvas : backCanvas;
  const currentPrintArea = selectedPrintArea;

  if (!file || !activeCanvas || !currentPrintArea) return;

  setDrawerOpen(false);
  setIsLoading(true);

  const reader = new FileReader();

  reader.onload = async (event) => {
    try {
      const dataUrl = event.target.result;

      // Create a fresh object URL to avoid any caching issues
      const objectURL = URL.createObjectURL(file);
      const fabricImg = await FabricImage.fromURL(objectURL);

      if (!fabricImg.width || !fabricImg.height) {
        throw new Error("Image dimensions are not available.");
      }

      // Optional DPI check (disabled here)
      const dpi = Math.round(fabricImg.width / (activeCanvas.width / 254));
      if (dpi < 150) {
        toast.error("Print quality bad, high resolution art required.");
      } else {
        toast.success("Print quality good.");
      }

      const clippingRect = getClippingRectForArea(currentPrintArea);
      const { maxWidth, maxHeight } = getMaxDimensionsForArea(currentPrintArea);

      if (!clippingRect) {
        console.error("Clipping rect not found for area:", currentPrintArea);
        return;
      }

      // Remove any existing image for this print area only
      activeCanvas.getObjects().forEach(obj => {
        if (obj.type === 'image' && obj.printArea === currentPrintArea) {
          activeCanvas.remove(obj);
        }
      });

      // Scale and position
      const scaleFactor = Math.min(
        clippingRect.width / fabricImg.width,
        clippingRect.height / fabricImg.height
      );

      fabricImg.set({
        scaleX: scaleFactor,
        scaleY: scaleFactor,
        left: clippingRect.left + (clippingRect.width - fabricImg.width * scaleFactor) / 2,
        top: clippingRect.top + (clippingRect.height - fabricImg.height * scaleFactor) / 2,
        clipPath: new Rect({
          left: clippingRect.left,
          top: clippingRect.top,
          width: clippingRect.width,
          height: clippingRect.height,
          absolutePositioned: true,
        }),
        printArea: currentPrintArea
      });

      // Style controls
      fabricImg.setControlsVisibility({
        mt: false, mb: false, ml: false, mr: false,
        tl: true, tr: true, bl: true, br: true
      });

      fabricImg.set({
        cornerSize: 30,
        borderWidth: 10,
        borderColor: 'blue',
        cornerColor: 'blue',
        cornerStrokeColor: 'black',
        transparentCorners: false
      });

      // Event for resizing/scaling
      fabricImg.on('scaling', () => {
        const adjustedWidthUnits = (fabricImg.width * fabricImg.scaleX) / (clippingRect.width / maxWidth);
        const adjustedHeightUnits = (fabricImg.height * fabricImg.scaleY) / (clippingRect.height / maxHeight);
        updateCostAndSize(adjustedWidthUnits, adjustedHeightUnits, currentPrintArea);
      });

      fabricImg.on('scaled', () => {
        fabricImg.set({ scaleX: 1, scaleY: 1 });
      });

      activeCanvas.add(fabricImg);
      activeCanvas.setActiveObject(fabricImg);
      activeCanvas.requestRenderAll();

      // Firebase Upload
      const timestamp = Date.now();
      const fileRef = ref(Storage, `designs/joggers-${currentPrintArea}-${timestamp}.png`);
      await uploadBytes(fileRef, file);
      const designImageUrl = await getDownloadURL(fileRef);

      // Set state
      setDesignFileNames(prev => ({
        ...prev,
        [currentPrintArea]: file.name
      }));

      setDesignImages(prev => ({
        ...prev,
        [currentPrintArea]: file
      }));

      setDesignImageUrls(prev => ({
        ...prev,
        [currentPrintArea]: designImageUrl
      }));

      // Initial cost calculation
      const initialWidthUnits = (fabricImg.width * scaleFactor) / (clippingRect.width / maxWidth);
      const initialHeightUnits = (fabricImg.height * scaleFactor) / (clippingRect.height / maxHeight);
      updateCostAndSize(initialWidthUnits, initialHeightUnits, currentPrintArea);

    } catch (error) {
      console.error("Error uploading image:", error);
      toast.error("Failed to upload image. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  reader.readAsDataURL(file);
};


  const organizeDesignImages = () => {
    const front = {};
    const back = {};
    
    Object.keys(designImageUrls).forEach(key => {
      if (designImageUrls[key]) {
        if (key.startsWith('front')) {
          front[key] = designImageUrls[key];
        } else if (key.startsWith('back')) {
          back[key] = designImageUrls[key];
        }
      }
    });
    
    return { front, back };
  };



    const organizePrintSizes = () => {
    const front = {};
    const back = {};
    
    Object.keys(designSizes).forEach(key => {
      if (designSizes[key].width > 0 || designSizes[key].height > 0) {
        if (key.startsWith('front')) {
          front[key] = designSizes[key];
        } else if (key.startsWith('back')) {
          back[key] = designSizes[key];
        }
      }
    });
    
    return { front, back };
  };
  


  const organizeDesignCosts = () => {
    const front = {};
    const back = {};
    
    Object.keys(designCosts).forEach(key => {
      if (designCosts[key] > 0) {
        if (key.startsWith('front')) {
          front[key] = designCosts[key];
        } else if (key.startsWith('back')) {
          back[key] = designCosts[key];
        }
      }
    });
    
    return { front, back };
  };

  const handleSubmit = async (status) => {
    setErrors({
      designName: '',
      description: '',
      sellingPrice: '',
      designImages: '',
      selectedMethod: ''
    });

    // Validation
    let isValid = true;
    const newErrors = {};

    if (!designName) {
      newErrors.designName = 'Design Name is required';
      isValid = false;
    }
    if (!description) {
      newErrors.description = 'Description is required';
      isValid = false;
    }
    if (!sellingPrice) {
      newErrors.sellingPrice = 'Selling Price is required';
      isValid = false;
    }
    
    const hasDesigns = Object.values(designImages).some(img => img !== null);
    if (!hasDesigns) {
      newErrors.designImages = 'Please upload at least one design image';
      isValid = false;
    }

    if (!selectedMethod) {
      newErrors.selectedMethod = 'Please select a print method';
      isValid = false;
    }

    if (!isValid) {
      setErrors(newErrors);
      return;
    }

    setIsSubmitting(true);
    setIsLoading(true);

    const updateProgress = (percentage) => {
      setProgress(percentage);
    };

    try {
      const dataURItoBlob = (dataURI) => {
        const byteString = dataURI.split(',')[1];
        const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        const ia = new Uint8Array(atob(byteString).split('').map(char => char.charCodeAt(0)));
        return new Blob([ia], { type: mimeString });
      };

      const saveCanvasToStorage = async (canvas, canvasName) => {
        canvas.getObjects("rect").forEach((rect) => rect.set({ visible: false }));
        canvas.renderAll();
        const timestamp = Date.now();
        const canvasPNG = canvas.toDataURL({ format: 'jpeg' });
        const canvasRef = ref(Storage, `mockups/joggers-${designName}-${canvasName}-${timestamp}.jpeg`);

        updateProgress(30);

        await uploadBytes(canvasRef, dataURItoBlob(canvasPNG));
        const url = await getDownloadURL(canvasRef);
        return url;
      };

      const generateSKUs = () => {
        const randomNum = Math.floor(Math.random() * 1000000);
        const productSizes = product?.sizes || [];
        return productSizes.map(size => `u-${randomNum}-${size}`);
      };

      const skus = generateSKUs();

      const frontMockupUrl = await saveCanvasToStorage(frontCanvas, 'front');
      updateProgress(50);
      const backMockupUrl = await saveCanvasToStorage(backCanvas, 'back');
      updateProgress(70);

      // Organize design images by front/back
      const organizedDesignImages = organizeDesignImages();

      const organizedPrintSizes = organizePrintSizes();

      const organizedPrintCosts = organizeDesignCosts();

      // Create design document in Firestore
      const designRef = doc(collection(db, 'users', user.uid, 'designs'));
      await setDoc(designRef, {
        designName,
        description,
        sellingPrice,
        totalPrice,
        productType: 'joggers',
        designImages: organizedDesignImages, // Changed to organized structure
        images: {
          front: frontMockupUrl,
          back: backMockupUrl,
        },
        costs: organizedPrintCosts,
        Printsizes: organizedPrintSizes,
        productName: product?.name || 'Cotton Joggers',
        productGSM: product?.GSM,
        SKUs: skus,
        baseCost: product?.BASE_COST,
        PrintCost: Object.values(designCosts).reduce((sum, cost) => sum + cost, 0),
        timestamp: serverTimestamp(),
        printMethod: selectedMethod,
        userId: user.uid
      });

      const userDocRef = doc(db, 'users', user.uid);
      const userDoc = await getDoc(userDocRef);
  
      if (!userDoc.exists()) {
        toast.error("User data not found.");
        return;
      }
  
      const userData = userDoc.data();
      const userShop = userData.shop;
      
      if (!userShop) {
        toast.error("Shop information is missing. Please check your user data.");
        return;
      }

      const payload = {
        productName: productName,
        frontImage: frontMockupUrl,
        backImage: backMockupUrl,
        designImages: organizedDesignImages, // Changed to organized structure
        shop: userShop,
        designName: designName,
        description: description,
        sellingPrice: sellingPrice,
        SKUs: skus,
        PrintCost: Object.values(designCosts).reduce((sum, cost) => sum + cost, 0),
        userId: user.uid,
        productType: 'joggers'
      };

      await axios.post('https://ufb-1.onrender.com/api/create-active-product', {
        ...payload,
        status,
      });

      toast.success('Joggers design uploaded successfully!');
      setShowModal(true);
    } catch (error) {
      console.error("Error uploading design:", error);
      toast.error("Failed to upload design.");
    } finally {
      setIsSubmitting(false);
      setIsLoading(false);
      setProgress(100);
    }
  };

  const handleSaveProduct = async () => {
    // Similar to handleSubmit but without API call to external service
    setErrors({
      designName: '',
      description: '',
      sellingPrice: '',
      designImages: '',
      selectedMethod: ''
    });

    let isValid = true;
    const newErrors = {};

    if (!designName) {
      newErrors.designName = 'Design Name is required';
      isValid = false;
    }
    if (!description) {
      newErrors.description = 'Description is required';
      isValid = false;
    }
    if (!sellingPrice) {
      newErrors.sellingPrice = 'Selling Price is required';
      isValid = false;
    }
    
    const hasDesigns = Object.values(designImages).some(img => img !== null);
    if (!hasDesigns) {
      newErrors.designImages = 'Please upload at least one design image';
      isValid = false;
    }

    if (!selectedMethod) {
      newErrors.selectedMethod = 'Please select a print method';
      isValid = false;
    }

    if (!isValid) {
      setErrors(newErrors);
      return;
    }

    setIsSubmitting(true);
    setIsLoading(true);

    try {
      const dataURItoBlob = (dataURI) => {
        const byteString = dataURI.split(',')[1];
        const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        const ia = new Uint8Array(atob(byteString).split('').map(char => char.charCodeAt(0)));
        return new Blob([ia], { type: mimeString });
      };

      const saveCanvasToStorage = async (canvas, canvasName) => {
        canvas.getObjects("rect").forEach((rect) => rect.set({ visible: false }));
        canvas.renderAll();
        const timestamp = Date.now();
        const canvasPNG = canvas.toDataURL({ format: 'jpeg' });
        const canvasRef = ref(Storage, `mockups/joggers-${designName}-${canvasName}-${timestamp}.jpeg`);

        await uploadBytes(canvasRef, dataURItoBlob(canvasPNG));
        const url = await getDownloadURL(canvasRef);
        return url;
      };

      const generateSKUs = () => {
        const randomNum = Math.floor(Math.random() * 1000000);
        const productSizes = product?.sizes || [];
        return productSizes.map(size => `u-j${randomNum}-${size}`);
      };

    
      const skus = generateSKUs();

      const frontMockupUrl = await saveCanvasToStorage(frontCanvas, 'front');
      const backMockupUrl = await saveCanvasToStorage(backCanvas, 'back');

      // Organize design images by front/back
      const organizedDesignImages = organizeDesignImages();

      const organizedPrintSizes = organizePrintSizes();

      const organizedPrintCosts = organizeDesignCosts();

      const designRef = doc(collection(db, 'users', user.uid, 'designs'));
      await setDoc(designRef, {
        designName,
        description,
        sellingPrice,
        totalPrice,
        productType: 'joggers',
        designImages: organizedDesignImages, // Changed to organized structure
        images: {
          front: frontMockupUrl,
          back: backMockupUrl,
        },
        costs: organizedPrintCosts,
        Printsizes: organizedPrintSizes,
        productName: product?.name || 'Cotton Joggers',
        productGSM: product?.GSM,
        SKUs: skus,
        baseCost: product?.BASE_COST,
        PrintCost: Object.values(designCosts).reduce((sum, cost) => sum + cost, 0),
        timestamp: serverTimestamp(),
        printMethod: selectedMethod,
        userId: user.uid
      });

      toast.success('Joggers design saved successfully!');
      setShowModal(true);
    } catch (error) {
      console.error("Error saving design:", error);
      toast.error("Failed to save design.");
    } finally {
      setIsSubmitting(false);
      setIsLoading(false);
    }
  };

  

  useEffect(() => {
    const fetchUserShop = async () => {
      const userDocRef = doc(db, 'users', user.uid);
      const userDoc = await getDoc(userDocRef);

      if (!userDoc.exists()) {
        toast.error("User data not found.");
        return;
      }

      const userData = userDoc.data();
      const userShop = userData.shop;
      setUserShop(userShop);
    };

    fetchUserShop();
  }, [user.uid]);

  const handleGoToProducts = () => {
    navigate('/products');
  };

  const handleRotate = () => {
    const activeCanvas = view === 0 ? frontCanvas : backCanvas;
    const activeObjects = activeCanvas.getActiveObjects();

    activeObjects.forEach((obj) => {
      obj.rotate(obj.angle + 90);
      obj.setCoords();
    });
    activeCanvas.renderAll();
  };


  
  const handleDelete = () => {
  const activeCanvas = view === 0 ? frontCanvas : backCanvas;
  const activeObjects = activeCanvas.getActiveObjects();

  // If there are selected objects, delete them
  if (activeObjects.length > 0) {
    activeObjects.forEach((obj) => {
      activeCanvas.remove(obj);
      
      // If the deleted object has a printArea, reset its cost and size
      if (obj.printArea) {
        updateCostAndSize(0, 0, obj.printArea);
        
        // Clear the design data for this print area
        setDesignImages(prev => ({
          ...prev,
          [obj.printArea]: null
        }));
        
        setDesignImageUrls(prev => ({
          ...prev,
          [obj.printArea]: null
        }));
        
        setDesignFileNames(prev => ({
          ...prev,
          [obj.printArea]: ''
        }));
      }
    });
  } else {
    // If no objects are selected, delete designs for the currently selected print area
    const designsToDelete = activeCanvas.getObjects().filter(obj => 
      obj.printArea === selectedPrintArea && obj.type === 'image'
    );
    
    designsToDelete.forEach((obj) => {
      activeCanvas.remove(obj);
    });
    
    // Reset the cost and size for the current print area
    updateCostAndSize(0, 0, selectedPrintArea);
    
    // Clear the design data for the selected print area
    setDesignImages(prev => ({
      ...prev,
      [selectedPrintArea]: null
    }));
    
    setDesignImageUrls(prev => ({
      ...prev,
      [selectedPrintArea]: null
    }));
    
    setDesignFileNames(prev => ({
      ...prev,
      [selectedPrintArea]: ''
    }));
  }
  
  activeCanvas.discardActiveObject();
  activeCanvas.renderAll();
};
  
  const handleShowSizeChart = () => {
    setIsSizeChartVisible(!isSizeChartVisible);
  };

  const setOpenDrawer = (isOpen) => {
    setDrawerOpen(isOpen);
  };

  // Calculate total design costs
  const totalDesignCost = Object.values(designCosts).reduce((sum, cost) => sum + cost, 0);

  // Get current view areas for print area selection


  return (
    <div className="one">
      <ToastContainer limit={1} closeOnClick/>
      <Header/>
      <div className="design-upload-container">
        <Sidebar />
        <div className={`drawer ${drawerOpen ? 'open' : ''}`}>
          <div className="drawer-header">
            <button className="close-drawer" onClick={() => setOpenDrawer(false)}>
              <FaTimes/>
            </button>
          </div>
  
          <div className="form-wrapper">
            <h2 className='hideee'>Design Upload</h2>
  
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <div className="print-method-container">
                  <h3>PRINT METHOD</h3>
                  <div className="print-method-buttons">
                    {availablePrintMethods.map((printMethod) => (
                      <button
                        key={printMethod}
                        className={`print-method-button ${selectedMethod === printMethod ? 'active' : ''}`}
                        onClick={(event) => {
                          event.preventDefault();
                          handlePrintMethodChange(printMethod);
                        }}
                      >
                        {printMethod}
                      </button>
                    ))}
                  </div>
                  {errors.selectedMethod && <p className="error">{errors.selectedMethod}</p>}
                </div>
  
                <div className="print-area-container">
                  <h3>SELECT PRINT AREA</h3>
                  <select 
                    value={selectedPrintArea} 
                    onChange={handlePrintAreaChange}
                    className="print-area-select"
                  >
                    <optgroup label="Front Areas">
                      {printAreaOptions.front.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </optgroup>
                    <optgroup label="Back Areas">
                      {printAreaOptions.back.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </optgroup>
                  </select>
                </div>
  
                <div className="form-group">
                  <label>Upload Design Image:</label>
                  <input
                    type="file"
                    accept=".png"
                    onChange={handleFileUpload}
                    required
                    style={{ display: 'none' }}
                    id="designImage"
                  />
                  <label htmlFor="designImage" className="custom-file-upload">
                    + Add Image
                  </label>
  
                  {Object.keys(designFileNames).map((key) => {
                    if (designFileNames[key]) {
                      return (
                        <p key={key}>Uploaded for {key}: {designFileNames[key]}</p>
                      );
                    }
                    return null;
                  })}
                </div>
  
                <label htmlFor="designName">Product Name:</label>
                <input
                  type="text"
                  id="designName"
                  value={designName}
                  onChange={(e) => setDesignName(e.target.value)}
                  placeholder="Product Name"
                  required            
                />
                {errors.designName && <p className="error">{errors.designName}</p>}
              </div>
  
              <div className="form-group">
                <label htmlFor="description">Description:</label>
                <textarea
                  id="description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Description"
                  required
                />
                {errors.description && <p className="error">{errors.description}</p>}
              </div>
  
              <div className="design-details">
                <div className="size-chart-link">
                  <span onClick={handleShowSizeChart}>View Size Chart</span>
                </div>
  
                {isSizeChartVisible && (
                  <div className="size-chart">
                    <h3>Size Chart:</h3>
                    <img src={sizeChart} alt="Size Chart" />
                  </div>
                )}
                
                <p><label>GSM: {productGSM}</label></p>
                <p><label>Print Method: {selectedMethod}</label></p>
                
                {/* Display design details for each area that has a design */}
                {Object.keys(designSizes).map((area) => {
                  if (designSizes[area].width > 0 && designSizes[area].height > 0) {
                    return (
                      <div key={area}>
                        <p><label>{area} Size: {designSizes[area].width.toFixed(1)} x {designSizes[area].height.toFixed(1)} inches</label></p>
                        <p><label>{area} Cost: ₹{designCosts[area]}</label></p>
                      </div>
                    );
                  }
                  return null;
                })}
                
                <p><label>Base Cost: ₹{baseCost}</label></p>
                <p><label>Total Design Cost: ₹{totalDesignCost}</label></p>
                <p><label>Total Cost: ₹{totalPrice} + {tax} + Shipping</label></p>
              </div>
  
              <div className="form-group">
                <label htmlFor="sellingPrice">Selling Price:</label>
                <input
                  type="number"
                  id="sellingPrice"
                  value={sellingPrice}
                  onChange={handleSellingPriceChange}
                  placeholder="Enter Selling Price"
                  required
                />
                {errors.sellingPrice && <p className="error">{errors.sellingPrice}</p>}
              </div>
  
              <div className="Beee">
                {!userShop ? (
                  <button type="button" disabled={isSubmitting} onClick={handleSaveProduct} className="save-submit">
                    {isSubmitting ? 'Saving Product...' : 'Save Product'}
                  </button>
                ) : (
                  <>
                    <button type="button" disabled={isSubmitting} onClick={() => handleSubmit('active')} className="desktop-submit">
                      {isSubmitting ? 'Submitting...' : (
                        <>
                          Make It Live <FaShopify className="shopifyi" />
                        </>
                      )}
                    </button>
                    <button type="button" disabled={isSubmitting} onClick={() => handleSubmit('draft')} className="desktop-draft">
                      {isSubmitting ? 'Saving as Draft...' : (
                        <>
                          Save as Draft <FaShopify className="shopifyi" />
                        </>
                      )}
                    </button>

                    
                  </>
                )}
              </div>
              
              {userShop && (
                <div className='skualert'>*Do not change the SKU of the Shopify product after creation.</div>
              )}
            </form>
          </div>
  
          {showModal && (
            <Modal>
              <div className="modal-content">
                <h2>Your joggers design has been created successfully!</h2>
                <button onClick={handleGoToProducts}>Go to products page!</button>
              </div>
            </Modal>
          )}
          
          {isLoading && (
            <div className="loader-overlay">
              <img src="Video1.GIF" alt="Loading..." />
              <span></span>
              <div className="progress">
                <p>{progress}%</p>
              </div>
            </div>
          )}
        </div>
  
        <div className="mockup">
          <div className="view-and-customize">
            <select onChange={(e) => setView(Number(e.target.value))} className="view-select">
              <option value="0">Front</option>
              <option value="1">Back</option>
            </select>
        
            <button onClick={() => setOpenDrawer(true)} className="customize-button">
              Customize
            </button>
            <button onClick={handleRotate} className="control-button"><FaUndo/></button>
            <button onClick={handleDelete} className="control-button"><FaTrash/></button>
          </div>
          
          <div style={{ display: view === 0 ? 'block' : 'none' }}>
            <div className="canvas-wrapper">
              <canvas ref={frontCanvasRef} />
            </div>
          </div>
          
          <div style={{ display: view === 1 ? 'block' : 'none' }}>
            <div className="canvas-wrapper">
              <canvas ref={backCanvasRef} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  
  }; 
  
  export default DesignJoggers;